<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <div class="row dblock" style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);">
              <div class="row">
                <div class="col-md-12">
                  <vs-breadcrumb
                    align="left"
                    :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Admin/adminDashboard'
                    },
                    {
                      title: 'Add Relation - Designation',
                      url: '/#/dashboard/admin/relation-designation',
                      active: true
                    }
                  ]"
                  ></vs-breadcrumb>
                  <div class="heading mt-3">
                    <h3 class="text-secondary">Relation/Designation</h3>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <h6 class="sub-frm-title">Add Relation/Designation</h6>
                <div class="col-lg-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="floating-label d-flex">
                          <input
                            style="height: 38px;"
                            class="floating-input form-control"
                            v-model="relationTitle"
                            type="text"
                            placeholder=" "
                          />
                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;"></i>
                          </span>
                          <label class="lbl-label">
                            Name of Relation
                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                          </label>
                          <template v-if="isRelationUpdate">
                            <button class="btn btn-primary" @click="updateRelation()">Update</button>
                          </template>
                          <template v-else>
                            <button
                              v-if="relationTitle != ''"
                              class="btn btn-primary"
                              @click="addRelation()"
                            >Submit</button>
                            <button v-else class="btn btn-primary disabled">Submit</button>
                          </template>
                        </div>
                        <div class="table-responsive">
                          <table class="table table-hover">
                            <tr>
                              <th>Sr#</th>
                              <th>title</th>
                              <th>Added at</th>
                              <th>Action</th>
                            </tr>
                            <tr v-for="(item, index) in relationArr" v-bind:key="item.id">
                              <td>{{index+1}}</td>
                              <td>{{item.title}}</td>
                              <td>{{item.createdAt | formatDate}}</td>
                              <td>
                                <a @click="editRelation(item.id)">
                                  <vs-icon
                                    class="mr-4"
                                    icon="edit"
                                    style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                  ></vs-icon>
                                </a>
                                <a @click="deleteRelation(item.id)">
                                  <vs-icon
                                    class="mr-1"
                                    icon="delete"
                                    style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                  ></vs-icon>
                                </a>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="floating-label d-flex">
                          <input
                            style="height: 38px;"
                            class="floating-input form-control"
                            v-model="designationTitle"
                            type="text"
                            placeholder=" "
                          />
                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;"></i>
                          </span>
                          <label class="lbl-label">
                            Name of Trainee Designation
                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                          </label>
                          <template v-if="isDesignationUpdate">
                            <button class="btn btn-primary" @click="updateDesignation()">Update</button>
                          </template>
                          <template v-else>
                            <button
                              v-if="designationTitle != ''"
                              class="btn btn-primary"
                              @click="addDesignation()"
                            >Submit</button>
                            <button v-else class="btn btn-primary disabled">Submit</button>
                          </template>
                        </div>
                        <div class="table-responsive">
                          <table class="table table-hover">
                            <tr>
                              <th>Sr#</th>
                              <th>title</th>
                              <th>Added at</th>
                              <th>Action</th>
                            </tr>
                            <tr v-for="(item, index) in designationArr" v-bind:key="item.id">
                              <td>{{index+1}}</td>
                              <td>{{item.title}}</td>
                              <td>{{item.createdAt | formatDate}}</td>
                              <td>
                                <a @click="editDesignation(item.id)">
                                  <vs-icon
                                    class="mr-4"
                                    icon="edit"
                                    style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                  ></vs-icon>
                                </a>
                                <a @click="deleteDesignation(item.id)">
                                  <vs-icon
                                    class="mr-1"
                                    icon="delete"
                                    style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                  ></vs-icon>
                                </a>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

import "bootstrap/dist/css/bootstrap.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  data: () => ({
    isRelationUpdate: false,
    relationId: "",
    relationTitle: "",
    relationArr: [],
    isDesignationUpdate: false,
    designationId: "",
    designationTitle: "",
    designationArr: [],
    isSidebar: false
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.getRelation();
    this.getDesignation();
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    // This will submit form
    addRelation() {
      let self = this;
      if (this.relationTitle.trim().length == 0) {
        self.toastError("Please add some text");
      } else {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/relation/add", {
            title: this.relationTitle
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been Added successfully!");
              self.resetForm();
              self.getRelation();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    getRelation() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/relation/get/all"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.relationArr = response.data;
        });
    },
    deleteRelation(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(
                process.env.VUE_APP_BASE_PATH + "/relation/single/delete",
                {
                  id: id
                }
              )
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.getRelation();
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    editRelation(id) {
      this.isRelationUpdate = true;
      this.relationId = id;
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/relation/" + id + "/edit"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.relationTitle = response.data.title;
            window.scrollTo(0, 0);
          }
        });
    },
    updateRelation() {
      this.isRelationUpdate = false;
      let self = this;
      if (this.relationTitle.trim().length == 0) {
        self.toastError("Please add some text");
      } else {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/relation/single/update", {
            title: this.relationTitle,
            id: this.relationId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been Updated successfully!");
              self.resetForm();
              self.getRelation();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    addDesignation() {
      let self = this;
      if (this.designationTitle.trim().length == 0) {
        self.toastError("Please add some text");
      } else {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        this.openLoading();
        axios
          .post(
            process.env.VUE_APP_BASE_PATH + "/trainee-designation/add",
            {
              title: this.designationTitle
            }
          )
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been Added successfully!");
              self.resetForm();
              self.getDesignation();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    getDesignation() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/trainee-designation/get/all"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.designationArr = response.data;
        });
    },
    deleteDesignation(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(
                process.env.VUE_APP_BASE_PATH +
                  "/traineedesignation/single/delete",
                {
                  id: id
                }
              )
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.getDesignation();
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    editDesignation(id) {
      this.isDesignationUpdate = true;
      this.designationId = id;
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/traineedesignation/" +
            id +
            "/edit"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.designationTitle = response.data.title;
            window.scrollTo(0, 0);
          }
        });
    },
    updateDesignation() {
      this.isDesignationUpdate = false;
      let self = this;
      if (this.designationTitle.trim().length == 0) {
        self.toastError("Please add some text");
      } else {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        this.openLoading();
        axios
          .post(
            process.env.VUE_APP_BASE_PATH +
              "/traineedesignation/single/update",
            {
              title: this.designationTitle,
              id: this.designationId
            }
          )
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been Updated successfully!");
              self.resetForm();
              self.getDesignation();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    resetForm() {
      this.relationTitle = "";
      this.designationTitle = "";
    }
  }
};
</script>

<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.4;
}
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.addnew-btn {
  font-size: 12px;
  box-shadow: none;
  border-color: #6c757d;
  background-color: #6c757d;
  float: right;
  margin: 10px 0px;
}
.save-btn {
  box-shadow: none;
  font-size: 12px;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.delete-btn {
  font-size: 12px;
  box-shadow: none;
  /* border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61); */
  float: right;
  margin: 10px 0px 0px 5px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #ffffff;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

/****  floating-Lable style end ****/

/* Floating label css ends */

.display-table ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.display-table li {
  float: left;
  padding: 5px 5px;
}

.display-table li a {
  cursor: inherit;
  font-size: 14px;
  display: block;
  color: #747679;
  text-align: center;
  padding: 5px;
  text-decoration: none;
  background-color: #f1f1f1;
}
.tbl-head th {
  font-weight: 400 !important;
  color: rgba(7, 167, 225, 0.61);
}
.display-table {
  /* margin-bottom: 0px !important; */
  color: #8e8e8e;
}
.display-table th,
.display-table td {
  padding: 5px 10px !important;
  /* border: 1px dotted #07a7e14f; */
}
</style>

